/* unplugin-vue-components disabled */import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/ep/circle-close';
import { ElProgress as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/progress/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72e9f0b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "marginB10"
};
const _hoisted_2 = {
  class: "ellipsis"
};
const _hoisted_3 = {
  class: "flex items-center justify-between"
};
const _hoisted_4 = {
  class: "flex items-center"
};
import { useTaskStore } from '@/store/modules/downTask';
import { getValue, exportExcel } from '@/utils/util';
export default /*#__PURE__*/_defineComponent({
  props: {
    task: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    // import API from './api';
    // import { Task } from '@/store/modules/downTask';
    const {
      delTask
    } = useTaskStore();
    const percent = ref(0);
    const page = ref(1);
    const tableData = ref([]);
    const cancel = ref(false);
    const clear = ref(false);
    const isComplete = ref(false);
    const deleteTask = () => {
      if (!isComplete.value && percent.value > 0) {
        ElMessageBox.confirm('正在下载，确定取消吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          cancel.value = true;
          delTask(props.task.id);
        });
      } else {
        delTask(props.task.id);
      }
    };
    const getData = async (_page = 1) => {
      let task = props.task;
      if (!task.api) {
        ElMessage.error(`${task.api}没有注册!`);
        deleteTask();
        return;
      }
      const pageSize = task.customPageSize || 1000;
      let res = await task.api({
        [task.page]: _page,
        [task.pageSize]: pageSize,
        ...task.params
      });
      if (res.code === 0) {
        let total = getValue(task.total || 'pageTotal', res) || 2000;
        let data = getValue(task.data, res);
        percent.value = Number(Number(100 / Math.ceil(total / pageSize) * _page).toFixed(2));
        tableData.value = tableData.value.concat(data);
        if (data && data.length === pageSize && !cancel.value && !clear.value) {
          getData(++page.value);
        } else {
          percent.value = 100;
          isComplete.value = true;
        }
      } else {
        delTask(task.id);
      }
    };
    watch(() => props.task, val => {
      if (val.id) {
        getData();
      }
    }, {
      deep: true,
      immediate: true
    });
    const handleExportExcel = () => {
      let excel = props.task.excel;
      exportExcel(excel.header, excel.field, tableData.value, excel.title);
    };
    return (_ctx, _cache) => {
      const _component_el_progress = __unplugin_components_0;
      const _component_i_ep_CircleClose = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.task.excel && __props.task.excel.title), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_progress, {
        style: {
          "width": "85%"
        },
        percentage: percent.value,
        status: percent.value < 100 ? 'exception' : 'success'
      }, null, 8, ["percentage", "status"]), _createElementVNode("div", _hoisted_4, [percent.value >= 100 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "down-btn marginL10",
        onClick: handleExportExcel
      }, "下载")) : _createCommentVNode("", true), _createVNode(_component_el_icon, {
        onClick: deleteTask
      }, {
        default: _withCtx(() => [_createVNode(_component_i_ep_CircleClose)]),
        _: 1
      })])])]);
    };
  }
});